import { createSlice } from "@reduxjs/toolkit";
import {
  getAdditionalDocuments,
  getDigitalLetterForExternalUser,
  replyLetterAsExternalUser,
  sendDisapprovalMail,
  uploadBankCertificate,
} from "../actions/bank";
import { formatErrorMessage } from "../../../helpers/helpers";

const initialState = {
  bankUserLoading: false,
  bankUserErrorMsg: null,
  bankUserSuccessMsg: null,
  certificateManagement: {
    certificatesData: [],
    newData: false,
    certificateDetails: "",
    additionalDocs: [],
    showCertificateForm: false,
    showDocumentViewerModal: false,
    document_url: "",
    showStatusChangeConfirmation: false,
    showCommentForm: false,
    comments: [],
    newComment: false,
    otp: "",
    reference_number: "",
    // certificateStatus: '',
    // certificateStatusConfirmationBtnText: '',
    // documentType: 'Certificate'
  },
  userManagement: {
    usersData: [],
  },
  searchResult: {
    searchResultData: {},
    newData: false,
    searchResultDetails: "",
    certificateSearchValue: "",
  },
  digitalLetterManagement: {
    inboxLetters: [],
    draftLetters: [],
    sentLetters: [],
    inboxLetterDetails: "",
    draftLetterDetails: "",
    sentLetterDetails: "",
    activeEmailTab: "inbox",
    showDeleteConfirmationForm: false,
    showAttachmentModal: false,
    newLetter: false,
    // letterStatus: ''
  },
  externalUser: {
    isFetching: false,
    letterDetails: null,
    errorMessage: null,
  },
};

export const bankUserSlice = createSlice({
  name: "bankUserApp",
  initialState,
  reducers: {
    clearAll: (state, action) => {
      state.bankUserLoading = false;
      state.bankUserErrorMsg = null;
      state.bankUserSuccessMsg = null;
    },
    clearOnReload: (state, action) => {
      state.certificateManagement = {
        ...initialState.certificateManagement,
        certificateDetails: state.certificateManagement.certificateDetails,
        otp: state.certificateManagement.otp,
        reference_number: state.certificateManagement.reference_number,
      };
      state.digitalLetterManagement = {
        ...initialState.digitalLetterManagement,
        inboxLetterDetails: state.digitalLetterManagement.inboxLetterDetails,
        sentLetterDetails: state.digitalLetterManagement.sentLetterDetails,
        draftLetterDetails: state.digitalLetterManagement.draftLetterDetails,
      };
      state.searchResult = {
        ...initialState.searchResult,
        certificateSearchValue: state.searchResult.certificateSearchValue,
      };
    },
    clearResponseMsg: (state, action) => {
      state.bankUserErrorMsg = null;
      state.bankUserSuccessMsg = null;
    },
    setLoadingBankUser: (state, action) => {
      state.bankUserLoading = action?.payload?.loading;
    },
    clearResetBot: (state) => {
      state.certificateManagement.newData = false;
      state.certificateManagement.newComment = false;
      state.digitalLetterManagement.newLetter = false;
      state.searchResult.newData = false;
    },
    setErrorMessageBankUser: (state, action) => {
      let msg = action.payload.message;
      state.bankUserLoading = false;
      state.bankUserErrorMsg = msg;
    },
    setSuccessMessageBankUser: (state, action) => {
      let msg = action.payload.message;
      state.bankUserLoading = false;
      state.bankUserSuccessMsg = msg;
    },
    logoutBankUser: (state, action) => {
      return initialState;
    },
    onGetComments: (state, action) => {
      state.bankUserSuccessMsg = "";
      state.certificateManagement.comments = action.payload;
    },

    onGetCertificates: (state, action) => {
      state.bankUserSuccessMsg = "";
      state.certificateManagement.certificatesData = action.payload;
      state.certificateManagement.newData = true;
    },
    onGetInboxLetters: (state, action) => {
      state.bankUserSuccessMsg = "";
      state.digitalLetterManagement.inboxLetters = action.payload;
    },
    onGetDraftLetters: (state, action) => {
      state.bankUserSuccessMsg = "";
      state.digitalLetterManagement.draftLetters = action.payload;
    },
    onGetSentLetters: (state, action) => {
      state.bankUserSuccessMsg = "";
      state.digitalLetterManagement.sentLetters = action.payload;
    },
    onAddCertificate: (state, action) => {
      state.certificateManagement.showCertificateForm = false;
      state.bankUserErrorMsg = "";
      state.bankUserSuccessMsg = "Certificate Uploaded Successfully";
    },
    onAddComment: (state, action) => {
      // state.certificateManagement.showCommentForm = false
      state.bankUserSuccessMsg = action.payload.message;
      // state.certificateManagement.newComment = true
    },
    onSendLetter: (state, action) => {
      state.bankUserSuccessMsg = action.payload.message;
    },
    onSearch: (state, action) => {
      state.searchResult.certificateSearchValue = action.payload.searchValue;
    },
    onDeleteLetter: (state, action) => {
      state.bankUserSuccessMsg = "Letter Deleted Successfully";
      state.digitalLetterManagement.showDeleteConfirmationForm = false;
      state.digitalLetterManagement.newLetter = true;
    },
    onChangeStatus: (state, action) => {
      state.bankUserSuccessMsg = action.payload.message;
      state.certificateManagement.certificateDetails = {
        ...state.certificateManagement.certificateDetails,
        CERTIFICATE_STATUS: action.payload.status,
        SWIFT_NUMBER: action.payload.code,
      };
      state.digitalLetterManagement.showStatusChangeConfirmation = false;
    },
    // onShowAttachment: (state, action) => {
    //     state.digitalLetterManagement.showAttachmentModal = false
    // },
    showCertificateFormFunc: (state, action) => {
      state.certificateManagement.showCertificateForm = action.payload.modal;
    },
    // showCommentFormFunc: (state, action) => {
    //     state.certificateManagement.showCommentForm = action.payload.modal
    // },
    showDeleteConfirmationFunc: (state, action) => {
      state.digitalLetterManagement.showDeleteConfirmationForm =
        action.payload.modal;
    },
    // showStatusChangeConfirmationFunc: (state, action) => {
    //     state.certificateManagement.showStatusChangeConfirmation = action.payload.modal
    // },
    showAttachmentFunc: (state, action) => {
      state.digitalLetterManagement.showAttachmentModal = action.payload.modal;
    },
    setCertificateDetails: (state, action) => {
      state.certificateManagement.certificateDetails = action.payload.details;
      // state.certificateManagement.showCustomerSuccessModal = action.payload.modal
    },
    setSearchResultDetails: (state, action) => {
      state.searchResult.searchResultDetails = action.payload.details;
      // state.certificateManagement.showCustomerSuccessModal = action.payload.modal
    },
    setInboxLetterDetails: (state, action) => {
      state.digitalLetterManagement.inboxLetterDetails = action.payload.details;
      // state.certificateManagement.showCustomerSuccessModal = action.payload.modal
    },
    setDraftLetterDetails: (state, action) => {
      state.digitalLetterManagement.draftLetterDetails = action.payload.details;
      // state.certificateManagement.showCustomerSuccessModal = action.payload.modal
    },
    setSentLetterDetails: (state, action) => {
      state.digitalLetterManagement.sentLetterDetails = action.payload.details;
      // state.certificateManagement.showCustomerSuccessModal = action.payload.modal
    },
    onGetSearchResult: (state, action) => {
      state.bankUserSuccessMsg = "";
      // state.searchResult.searchResultData = action.payload
      // state.searchResult.newData = true
    },
    setActiveEmailTab: (state, action) => {
      state.digitalLetterManagement.activeEmailTab = action.payload.name;
    },
    onGetUsers: (state, action) => {
      state.bankUserSuccessMsg = "";
      state.userManagement.usersData = action.payload;
    },
    onVerifyLink: (state, action) => {
      state.certificateManagement.otp = action.payload.otp;
      state.certificateManagement.reference_number = action.payload.reference;
    },
    // setConfirmationStatusModalText: (state, action) =>{
    //     state.certificateManagement.certificateStatus = action.payload.status ?? state.certificateManagement.certificateStatus
    //     state.certificateManagement.certificateStatusConfirmationBtnText = action.payload.btnText ?? state.certificateManagement.certificateStatusConfirmationBtnText
    //     state.certificateManagement.documentType = action.payload.documentType ??  state.certificateManagement.documentType
    // },
    showDocumentViewerModalFunc: (state, action) => {
      state.certificateManagement.showDocumentViewerModal =
        action.payload.modal;
      state.certificateManagement.document_url = action.payload.url;
    },
    onGetAdditionalDocuments: (state, action) => {
      state.bankUserSuccessMsg = "";
      state.certificateManagement.additionalDocs = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAdditionalDocuments.fulfilled, (state, action) => {
        state.bankUserSuccessMsg = "";
        state.certificateManagement.additionalDocs = action.payload.data;
      })
      .addCase(uploadBankCertificate.pending, (state) => {
        state.bankUserLoading = true;
        state.bankUserErrorMsg = "";
        state.bankUserSuccessMsg = "";
      })
      .addCase(uploadBankCertificate.fulfilled, (state) => {
        state.bankUserLoading = false;
        state.bankUserErrorMsg = "";
        state.bankUserSuccessMsg =
          "Confirmation of reasonableness request sent successfully.";
      })
      .addCase(uploadBankCertificate.rejected, (state, action) => {
        state.bankUserLoading = false;
        state.bankUserSuccessMsg = "";

        if (action.payload)
          state.bankUserErrorMsg =
            action.payload.error || action.payload.message;
        else state.bankUserErrorMsg = formatErrorMessage(action.error);
      })
      .addCase(sendDisapprovalMail.pending, (state) => {
        state.bankUserLoading = true;
        state.bankUserErrorMsg = "";
        state.bankUserSuccessMsg = "";
      })
      .addCase(sendDisapprovalMail.fulfilled, (state) => {
        state.bankUserLoading = false;
        state.bankUserErrorMsg = "";
        state.bankUserSuccessMsg =
          "You have successfully sent an email to transferee to update missing and incorrect information.";
      })
      .addCase(sendDisapprovalMail.rejected, (state, action) => {
        state.bankUserLoading = false;
        state.bankUserSuccessMsg = "";

        if (action.payload)
          state.bankUserErrorMsg =
            action.payload.error || action.payload.message;
        else state.bankUserErrorMsg = formatErrorMessage(action.error);
      })
      .addCase(getDigitalLetterForExternalUser.pending, (state, action) => {
        state.externalUser.isFetching = true;
        state.externalUser.errorMessage = null;
      })
      .addCase(getDigitalLetterForExternalUser.fulfilled, (state, action) => {
        state.externalUser = {
          isFetching: false,
          errorMessage: null,
          letterDetails: action.payload.data,
        };
      })
      .addCase(getDigitalLetterForExternalUser.rejected, (state, action) => {
        state.externalUser.isFetching = false;
        state.externalUser.letterDetails = null;

        if (action.payload)
          state.externalUser.errorMessage =
            action.payload.error || action.payload.message;
        else state.externalUser.errorMessage = formatErrorMessage(action.error);
      })
      .addCase(replyLetterAsExternalUser.pending, (state, action) => {
        state.externalUser.isFetching = true;
        state.externalUser.errorMessage = null;
      })
      .addCase(replyLetterAsExternalUser.fulfilled, (state, action) => {
        state.externalUser = {
          isFetching: false,
          errorMessage: null,
          letterDetails: null,
        };
      })
      .addCase(replyLetterAsExternalUser.rejected, (state, action) => {
        state.externalUser.isFetching = false;

        if (action.payload)
          state.externalUser.errorMessage =
            action.payload.error || action.payload.message;
        else state.externalUser.errorMessage = formatErrorMessage(action.error);
      });
  },
});

// Action creators are generated for each case reducer function
export const {
  clearAll,
  clearResetBot,
  setErrorMessageBankUser,
  setLoadingBankUser,
  setSuccessMessageBankUser,
  onGetCertificates,
  setCertificateDetails,
  onGetComments,
  onChangeStatus,
  onGetSearchResult,
  showCertificateFormFunc,
  showCommentFormFunc,
  showDeleteConfirmationFunc,
  // showStatusChangeConfirmationFunc,
  onAddCertificate,
  onAddComment,
  onDeleteLetter,
  onGetInboxLetters,
  onGetDraftLetters,
  onGetSentLetters,
  clearResponseMsg,
  clearOnReload,
  logoutBankUser,
  setInboxLetterDetail,
  setActiveEmailTab,
  onSendLetter,
  onGetUsers,
  setInboxLetterDetails,
  setDraftLetterDetails,
  setSentLetterDetails,
  showAttachmentFunc,
  onSearch,
  setSearchResultDetails,
  onVerifyLink,
  setConfirmationStatusModalText,
  showDocumentViewerModalFunc,
  onGetAdditionalDocuments,
} = bankUserSlice.actions;

export default bankUserSlice.reducer;
